<template>
    <div>
        <h1 class="fd-news-title">{{ title }}</h1>
        <div class="fd-news-message">
            <p>发布时间：{{ date }}</p>
            <p>发布法院：{{ fy }}</p>
        </div>
    </div>

</template>

<script>
export default {
    name: 'index',
    data() {
        return {
            navList: [],
            title: '',
            date: '',
            fy: ''
        };
    }
};
</script>

<style lang="less" scoped>

</style>
